import React from 'react';
import { Card, Typography, Collapse, Space, Tag } from 'antd';
import { Link } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;
const { Panel } = Collapse;

const Faq = () => {
  const faqItems = [
    {
      key: '1',
      question: 'Qu\'est-ce que Nomidya ?',
      answer: 'Nomidya est une plateforme d\'e-learning qui propose une vaste gamme de MOOC (Massive Open Online Courses) professionnels. Notre plateforme éducative en ligne vous permet de développer des compétences de haut niveau dans domaines très demandés dans le marché de travail, en suivant des cours flexibles et accessibles de n\'importe où dans le monde.',
      tags: ['E-learning', 'MOOC', 'Formation professionnelle']
    },
    {
      key: '2',
      question: 'Qui sont les formateurs de Nomidya ?',
      answer: 'Nos formateurs sont des experts du secteur, possédant une riche expérience dans les domaines de SAP et de la gestion de projets. Ils sont soigneusement sélectionnés pour offrir des cours de haute qualité, basés sur des connaissances pratiques et concrètes, pour vous préparer au mieux à relever les défis professionnels actuels.',
      tags: ['Experts', 'SAP', 'Gestion de projets']
    },
    {
      key: '3',
      question: 'Comment m\'inscrire à un cours ?',
      answer: (
        <span>
          Pour vous inscrire à un cours, rendez-vous sur la page du cours qui vous intéresse et cliquez sur le bouton d'inscription. Suivez ensuite les étapes pour créer un compte sur Nomidya et procéder au paiement du cours. Une fois inscrit, vous pourrez accéder au contenu du cours et commencer votre apprentissage. 
          {' '}<Link to="/login" style={{ color: '#1890ff', fontWeight: 'bold' }}>S'inscrire/Se connecter</Link>
        </span>
      ),
      tags: ['Inscription', 'Compte', 'Paiement']
    },
    {
      key: '4',
      question: 'Quels sont les modes de paiement acceptés ?',
      answer: 'Nous acceptons les paiements par carte de crédit, carte de débit et PayPal. Toutes les transactions sont sécurisées et vos informations de paiement sont protégées.',
      tags: ['Paiement', 'Sécurité', 'PayPal']
    },
    {
      key: '5',
      question: 'Puis-je accéder au contenu du cours à tout moment ?',
      answer: 'Oui, vous pouvez accéder au contenu du cours à tout moment et étudier à votre propre rythme. Nos cours sont conçus pour être flexibles, vous permettant de suivre les leçons quand vous le souhaitez.',
      tags: ['Flexibilité', '24/7', 'Apprentissage autonome']
    },
    {
      key: '6',
      question: 'Est-ce que je reçois un certificat à la fin du cours ?',
      answer: 'Oui, à la fin de chaque cours, vous recevrez un certificat de réussite, attestant de votre participation et de votre achèvement du cours. Ce certificat peut être ajouté à votre CV et utilisé pour renforcer vos compétences professionnelles.',
      tags: ['Certificat', 'CV', 'Reconnaissance']
    },
    {
      key: '7',
      question: 'Puis-je poser des questions aux formateurs pendant le cours ?',
      answer: 'Oui, vous pouvez poser des questions aux formateurs pendant le cours. Nous encourageons les échanges et nous vous fournirons un support et des réponses à vos questions tout au long de votre parcours d\'apprentissage.',
      tags: ['Support', 'Questions', 'Interaction']
    }
  ];

  return (
    <div className="faq-page" style={{ padding: '20px 0' }}>
      <div className="container">
        <Card className="mb-4" style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
          {/* En-tête */}
          <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <Title level={1} style={{ color: '#1890ff' }}>
              Foire aux Questions (FAQ)
            </Title>
            <Paragraph style={{ fontSize: '16px', color: '#666', maxWidth: '800px', margin: '0 auto' }}>
              Bienvenue sur la page FAQ de Nomidya. Nous avons rassemblé ici les questions les plus fréquemment posées par nos apprenants. Consultez cette section pour trouver des réponses rapides et utiles à vos interrogations.
            </Paragraph>
          </div>

          {/* Message d'aide */}
          <Card style={{ 
            marginBottom: '30px',
            background: '#f0f2f5',
            textAlign: 'center',
            border: '2px dashed #1890ff'
          }}>
            <Text style={{ fontSize: '16px', color: '#1890ff' }}>
              Si vous ne trouvez pas ce que vous cherchez, n'hésitez pas à nous contacter, nous sommes là pour vous aider !
            </Text>
          </Card>

          {/* FAQ Accordion */}
          <Collapse 
            accordion
            size="large"
            style={{ background: 'transparent' }}
          >
            {faqItems.map((item) => (
              <Panel 
                header={
                  <Space>
                    <Text strong style={{ fontSize: '16px' }}>{item.question}</Text>
                  </Space>
                }
                key={item.key}
                style={{ marginBottom: '16px', borderRadius: '8px', border: '1px solid #e8e8e8' }}
              >
                <Card style={{ border: 'none', padding: '0' }}>
                  <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                    <Paragraph style={{ 
                      fontSize: '15px', 
                      lineHeight: '1.7', 
                      margin: 0,
                      textAlign: 'justify'
                    }}>
                      {item.answer}
                    </Paragraph>
                    <div>
                      {item.tags.map((tag, index) => (
                        <Tag key={index} color="blue" style={{ margin: '2px' }}>
                          {tag}
                        </Tag>
                      ))}
                    </div>
                  </Space>
                </Card>
              </Panel>
            ))}
          </Collapse>

          {/* Message de conclusion et contact */}
          <Card style={{ 
            marginTop: '30px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            textAlign: 'center'
          }}>
            <Title level={3} style={{ color: 'white', marginBottom: '16px' }}>
              Besoin d'aide supplémentaire ?
            </Title>
            <Paragraph style={{ 
              fontSize: '16px', 
              lineHeight: '1.7', 
              color: 'white',
              marginBottom: '16px'
            }}>
              Nous espérons que ces réponses vous ont été utiles. Si vous avez d'autres questions, n'hésitez pas à nous contacter.
            </Paragraph>
            <Paragraph style={{ 
              fontSize: '18px', 
              fontWeight: 'bold',
              color: '#ffd700',
              margin: 0
            }}>
              Nous sommes impatients de vous accompagner dans votre parcours d'apprentissage chez Nomidya.
            </Paragraph>
          </Card>

          {/* Contact rapide */}
          <Card style={{ 
            marginTop: '20px',
            background: '#fff7e6',
            border: '1px solid #faad14',
            textAlign: 'center'
          }}>
            <Space size="large" style={{ justifyContent: 'center' }}>
              <div>
                <div style={{ marginTop: '8px' }}>
                  <Text strong>Contact</Text>
                  <br />
                  <Text style={{ fontSize: '14px' }}>contact@nomidya.com</Text>
                </div>
              </div>
              <div>
                <div style={{ marginTop: '8px' }}>
                  <Text strong>Nos Cours</Text>
                  <br />
                  <Link to="/courses" style={{ fontSize: '14px' }}>Découvrir</Link>
                </div>
              </div>
              <div>
                <div style={{ marginTop: '8px' }}>
                  <Text strong>S'inscrire</Text>
                  <br />
                  <Link to="/register" style={{ fontSize: '14px' }}>Créer un compte</Link>
                </div>
              </div>
            </Space>
          </Card>
        </Card>
      </div>
    </div>
  );
};

export default Faq;